import { Component, EventEmitter, Inject, Input, Output, SimpleChanges } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { BaseComponent, CommonService } from "@rubii/frontend-common";
import { ConfigService } from "src/app/services/config.service";
import { RoleService } from "src/app/services/role.service";
import { EditUserComponent } from "../edit-user/edit-user.component";
import { AdvertiserAndAgency } from "../interfaces/advertiser-and-agency.interface";
import { ExUserAccessSource } from "../interfaces/ex-user-access-source.interface";
import { ClientService } from "../../services/client.service";

@Component({
    selector: 'app-ex-user-access-selector',
    templateUrl: './ex-user-access-selector.component.html',
    styleUrls: ['./ex-user-access-selector.component.scss']
})
export class ExUserAccessSelector extends BaseComponent {
    advertiserAndAgency: AdvertiserAndAgency[] = [];
    agencyMap: Map<number, AdvertiserAndAgency> = new Map();
    advertiserMap: Map<number, AdvertiserAndAgency> = new Map();
    advertiserAndAgencyFlatData = [];
    selectedAgencyMap: Map<number, AdvertiserAndAgency> = new Map();
    selectedAdvertiserMap: Map<number, AdvertiserAndAgency> = new Map();

    pannelVisible = false;
    exUserAccessName = '';

    private advertiserAgencyLoaded = false;
    externalUserAccessSourceLoaded = false;

    @Input() exUserAccessArr: ExUserAccessSource[] = [];
    @Output() selectedAccessChange: EventEmitter<any> = new EventEmitter();

    constructor(
        private config: ConfigService,
        private roleService: RoleService,
        private client: ClientService,
        private snack: MatSnackBar,
        private dialogRef: MatDialogRef<EditUserComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        super();
    }

    ngOnInit(): void {
        this.getAdvertiserAgency();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.updateExUserAccessSource();
    }

    togglePannel() {
        this.pannelVisible = !this.pannelVisible;
    }

    getExUserAccessName() {
        const selected = [...this.selectedAgencyMap.values(), ...this.selectedAdvertiserMap.values()];
        if (selected && selected.length > 2) {
            this.exUserAccessName = `${selected.length} items`;
        } else {
            this.exUserAccessName = selected.map(x => x.name).join(',');
        }
    }

    handleAdClick(checked: boolean, ad: AdvertiserAndAgency) {
        ad.selected = checked;
        if (checked) {
            this.selectedAdvertiserMap.set(ad.id, ad);
        } else {
            this.selectedAdvertiserMap.delete(ad.id);
        }
        this.getExUserAccessName();
        this.selectedAccessChange.emit({ advertisers: this.selectedAdvertiserMap.values(), agencies: this.selectedAgencyMap.values() });
    }


    handleAdOrAgencyClick(checked: boolean, adOrAgency: AdvertiserAndAgency) {
        adOrAgency.selected = checked;
        if (adOrAgency.isAgency) {
            if (checked) {
                this.selectedAgencyMap.set(adOrAgency.id, adOrAgency);
                for (const item of adOrAgency.children) {
                    item.selected = false;
                    this.selectedAdvertiserMap.delete(item.id);
                }
            } else {
                this.selectedAgencyMap.delete(adOrAgency.id);
            }
            this.getExUserAccessName();
            this.selectedAccessChange.emit({ advertisers: this.selectedAdvertiserMap.values(), agencies: this.selectedAgencyMap.values() });
        } else {
            this.handleAdClick(checked, adOrAgency);
        }
    }

    filterAdvertiserAndAgency(value: string) {
        let filterData = this.advertiserAndAgencyFlatData.filter(x => x.name.toLowerCase().includes(value.trim().toLowerCase()));
        filterData = filterData || [];

        const agencyMap = new Map();
        const adMap = new Map();
        for (const item of filterData) {
            if (item.isAgency) {
                if (item.children?.length) {
                    for (const ad of item.children) {
                        if (!adMap.has(ad.id)) {
                            adMap.set(ad.id, ad);
                        }
                    }
                }
                agencyMap.set(item.id, item);
            } else {
                if (item.agencyId) {
                    agencyMap.set(item.agencyId, this.agencyMap.get(item.agencyId));
                }
                if (!adMap.has(item.id)) {
                    adMap.set(item.id, item);
                }
            }
        }

        for (const key of this.agencyMap.keys()) {
            this.agencyMap.get(key).isVisible = agencyMap.has(key);
        }
        for (const key of this.advertiserMap.keys()) {
            this.advertiserMap.get(key).isVisible = adMap.has(key);
        }
    }

    getAdvertiserAgency() {
        this.advertiserAgencyLoaded = false;
        this.client.user.getAdvertiserAndAgency().then(res => {
            const data = res.map(a => ({...a, isVisible: true} as AdvertiserAndAgency));
            this.advertiserAndAgencyFlatData = data;
            for (const item of data) {
                if (item.isAgency) {
                    this.agencyMap.set(item.id, item);
                } else {
                    this.advertiserMap.set(item.id, item);
                }
            }
            let result = [];
            for (const item of data) {
                let agency = this.agencyMap.get(item.agencyId);
                if (agency) {
                    (agency.children || (agency.children = [])).push(item);
                } else {
                    result.push(item);
                }
            }
            this.advertiserAndAgency = result;
            this.advertiserAgencyLoaded = true;
            this.updateExUserAccessSource();
        })
        
    }

    updateExUserAccessSource() {
        if (!this.advertiserAgencyLoaded) {
            return;
        }
        for (const exUserAccess of this.exUserAccessArr) {
            if (exUserAccess.agencyId && !exUserAccess.advertiserId) {
                const agency = this.agencyMap.get(exUserAccess.agencyId);
                agency.selected = true;
                this.selectedAgencyMap.set(exUserAccess.agencyId, agency);
            } else if (exUserAccess.advertiserId) {
                const ad = this.advertiserMap.get(exUserAccess.advertiserId);
                ad.selected = true;
                this.selectedAdvertiserMap.set(exUserAccess.advertiserId, ad);
            }
        }
        this.selectedAccessChange.emit({ advertisers: this.selectedAdvertiserMap.values(), agencies: this.selectedAgencyMap.values() });
        this.getExUserAccessName();
    }
}